import type { SiteListItem } from "../../services/siteManagement/siteManagement.types";
import { formatDateTime } from "../../helpers/formatDateTime";

export interface PendingSite extends Partial<SiteListItem> {
    id: number;
    pendingSiteRequestGuid?: string;
    expiresAt?: string;
    expiredAt?: string;
}

export type PendingMode = "approve" | "reject";
export interface PendingAction {
    s: PendingSite;
    customerId?: number | null;
    reason?: string;
}
export interface PendingWorkflow {
    sites: PendingSite[];
    mode: PendingMode;
    bulk: boolean;
}

export const getPendingKey = (site: PendingSite): string =>
    site.pendingSiteRequestGuid ?? site.siteGuid ?? String(site.id);

export const getPendingErrorMessage = (error: unknown, fallback: string): string =>
    error instanceof Error && error.message ? error.message : fallback;

export const getPendingExpiry = (site: PendingSite): string | undefined =>
    formatDateTime(site.expiresAt) ? site.expiresAt : site.expiredAt;

export function getPendingList(data: PendingSite[] | Record<string, PendingSite>): PendingSite[] {
    return Array.isArray(data) ? data : Object.values(data);
}

export function validatePendingAction(item: PendingAction, mode: PendingMode): string {
    const guid = item.s.pendingSiteRequestGuid ?? item.s.siteGuid;
    if (!guid) throw new Error("Missing pending site identifier");
    if (mode === "approve" && (!item.customerId || !Number.isInteger(item.customerId) || item.customerId <= 0)) {
        throw new Error("Missing customer for pending site approval");
    }
    if (mode === "reject" && !item.reason?.trim()) throw new Error("Please provide a reason for rejected sites");
    return guid;
}
